import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IVw_Samithi_Members {
samithi_member_id:number,
name?:string,
surname?:string,
father_name?:string,
rev_addrs1:string,
rev_addrs2:string,
rev_addrs3:string,
rev_village:string,
rev_mandal:string,
pincode:string,
vibhag_id:number,
vibhag_name?:string,
zilla_id:number,
zilla_name?:string,
nagar_khanda_id:number,
nagar_khanda_name?:string,
upamandal_id:number,
upamandal_name?:string,
is_basti_gramam:string,
basti_gramam_id:number,
basti_name?:string,
status:boolean,
created_on:Date,
created_by:number,
modified_on:Date,
modified_by:number
}

interface IVw_Samithi_MembersData {
    list?: Array<IVw_Samithi_Members>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IVw_Samithi_MembersData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const vw_samithi_membersSlice = createSlice({
    name: "vw_samithi_members",
    initialState,
    reducers: {
        setVw_Samithi_MembersList: (state, _action: PayloadAction<IVw_Samithi_MembersData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetVw_Samithi_MembersToInit: (state) => {
            state = initialState;
        },
        setVw_Samithi_MembersMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setVw_Samithi_MembersList, resetVw_Samithi_MembersToInit, setVw_Samithi_MembersMessage } = vw_samithi_membersSlice.actions;

export default vw_samithi_membersSlice.reducer;

